<template>
	<v-tooltip top>
		<template v-slot:activator="{ on }">
			<v-btn
				v-on="on"
				icon
				small
				:loading="loading"
				:class="$vuetify.breakpoint.smAndDown ? 'mx-1' : 'mx-0'"
				@click.stop="impersonate">
				<v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" :color="params.color">{{ params.icon }}</v-icon>
			</v-btn>
		</template>
		<span>{{ params.text }}</span>
	</v-tooltip>
</template>

<script>
export default {
	name: 'portal-impersonate',
	props: {
		model: Object,
		params: Object,
		button: Object
	},
	data() {
		return {
			loading: false
		}
	},
	methods: {
		async impersonate() {
			this.loading = true
			try {
				const resp = await this.axios.post('portalusers/' + this.model.id + '/impersonate')
				if (resp.data.success) {
					window.open(resp.data.url, '_blank')
				} else {
					this.$store.commit('setSnackbar', {
						timeout: 4000,
						text: resp.data.message || 'Errore',
						value: true,
						color: 'error'
					})
				}
			} catch (e) {
				this.$store.commit('setSnackbar', {
					timeout: 4000,
					text: e.response?.data?.message || 'Errore nell\'impersonificazione',
					value: true,
					color: 'error'
				})
			} finally {
				this.loading = false
			}
		}
	}
}
</script>
